import { createAsyncThunk } from '@reduxjs/toolkit';
import { SourceFetchParams } from './Source.type';
import sourceService from './Source.service';

export const getSourceListThunk = createAsyncThunk(
  'source/getSourceListThunk',
  async (params: SourceFetchParams, thunkAPI) => {
    const response = await sourceService.getList(params);
    return response.data;
  },
);
